import { AudienceCapacityZone } from './audience-capacity-zone.model';

export class AudienceCapacity {

    private numberPeopleCurrent: number;
    private numberPeoplePrevious: number;
    private numberPeopleComparison: number;
    private peakHour: string;
    private peakNumber: number;
    private offPeakHour: string;
    private offPeakNumber: number;
    private averageNumberCurrent: number;
    private limitNumberCurrent: number;
    private averageNumberPrevious: number;
    private averageComparison: number;
    countInto: Array<number>;
    countExit: Array<number>;
    countIntoByZone: Array<AudienceCapacityZone>;
    countExitByZone: Array<AudienceCapacityZone>;

    constructor(numberPeopleCurrent?: number,
                numberPeoplePrevious?: number,
                numberPeopleComparison?: number,
                peakHour?: string,
                peakNumber?: number,
                offPeakHour?: string,
                offPeakNumber?: number,
                averageNumberCurrent?: number,
                limitNumberCurrent?: number,
                averageNumberPrevious?: number,
                averageComparison?: number,
                countInto?: Array<number>,
                countExit?: Array<number>,
                countIntoByZone?: Array<AudienceCapacityZone>,
                countExitByZone?: Array<AudienceCapacityZone>) {
                    this.numberPeopleCurrent = numberPeopleCurrent;
                    this.numberPeoplePrevious = numberPeoplePrevious;
                    this.numberPeopleComparison = numberPeopleComparison;
                    this.peakHour = peakHour;
                    this.peakNumber = peakNumber;
                    this.offPeakHour = offPeakHour;
                    this.offPeakNumber = offPeakNumber;
                    this.averageNumberCurrent = averageNumberCurrent;
                    this.limitNumberCurrent = limitNumberCurrent;
                    this.averageNumberPrevious = averageNumberPrevious;
                    this.averageComparison = averageComparison;
                    this.countInto = countInto;
                    this.countExit = countExit;
                    this.countIntoByZone = countIntoByZone;
                    this.countExitByZone = countExitByZone;
        }

    public get NumberPeopleCurrent(): number {
        return this.numberPeopleCurrent;
    }
    public get NumberPeoplePrevious(): number {
        return this.numberPeoplePrevious;
    }
    public get NumberPeopleComparison(): number {
        return this.numberPeopleComparison;
    }
    public get PeakHour(): string {
        return this.peakHour;
    }
    public get PeakNumber(): number {
        return this.peakNumber;
    }
    public get OffPeakHour(): string {
        return this.offPeakHour;
    }
    public get OffPeakNumber(): number {
        return this.offPeakNumber;
    }
    public get AverageNumberCurrent(): number {
        return this.averageNumberCurrent;
    }
    public get LimitNumberCurrent(): number {
        return this.limitNumberCurrent;
    }
    public get AverageNumberPrevious(): number {
        return this.averageNumberPrevious;
    }
    public get AverageComparison(): number {
        return this.averageComparison;
    }
    public get CountInto(): Array<number> {
        return this.countInto;
    }
    public get CountExit(): Array<number> {
        return this.countExit;
    }
    public get CountIntoByZone(): Array<AudienceCapacityZone> {
        return this.countIntoByZone;
    }
    public get CountExitByZone(): Array<AudienceCapacityZone> {
        return this.countExitByZone;
    }



    public set NumberPeopleCurrent(numberPeopleCurrent: number) {
        this.numberPeopleCurrent = numberPeopleCurrent;
    }
    public set NumberPeoplePrevious(numberPeoplePrevious: number) {
        this.numberPeoplePrevious = numberPeoplePrevious;
    }
    public set NumberPeopleComparison(numberPeopleComparison: number) {
        this.numberPeopleComparison = numberPeopleComparison;
    }
    public set PeakHour(peakHour: string) {
        this.peakHour = peakHour;
    }
    public set PeakNumber(peakNumber: number) {
        this.peakNumber = peakNumber;
    }
    public set OffPeakHour(offPeakHour: string) {
        this.offPeakHour = offPeakHour;
    }
    public set OffPeakNumber(offPeakNumber: number) {
        this.offPeakNumber = offPeakNumber;
    }
    public set AverageNumberCurrent(averageNumberCurrent: number) {
        this.averageNumberCurrent = averageNumberCurrent;
    }
    public set LimitNumberCurrent(limitNumberCurrent: number) {
        this.limitNumberCurrent = limitNumberCurrent;
    }
    public set AverageNumberPrevious(averageNumberPrevious: number) {
        this.averageNumberPrevious = averageNumberPrevious;
    }
    public set AverageComparison(averageComparison: number) {
        this.averageComparison = averageComparison;
    }
    public set CountInto(countInto: Array<number>) {
        this.countInto = countInto;
    }
    public set CountExit(countExit: Array<number>) {
        this.countExit = countExit;
    }
    public set CountIntoByZone(countIntoByZone: Array<AudienceCapacityZone>) {
        this.countIntoByZone = countIntoByZone;
    }
    public set CountExitByZone(countExitByZone: Array<AudienceCapacityZone>) {
        this.countExitByZone = countExitByZone;
    }

}
